exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circleFill-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 3%; }\n\n.circle {\n  overflow: hidden;\n  background-color: #ffffff;\n  border-radius: 100px;\n  border-width: 5px;\n  border-color: #ffc400;\n  width: 180px;\n  height: 180px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end; }\n\n.circleFill {\n  width: 100%;\n  background-color: #ffc400;\n  border-top-color: #ffc400;\n  border-top-width: 0px;\n  height: 0%; }\n\n.circleFillLogo {\n  align-self: center;\n  position: absolute;\n  width: 120px;\n  height: auto;\n  padding-bottom: 30px; }\n", ""]);

// exports
